module.exports = __webpack_public_path__ + "img/4.a2f78de9.png";